export class Area {
	public constructor(
		public readonly identity: string,
		public readonly name: string,
		public readonly countryIdentity: string
	) {}
}
